<template>
  <div class="question" v-show="questionNumber === answerCount">
    <div class="question__top">
      <div :class="'question__title-wrap question__title-wrap--' + (Number(questionNumber) + 1)">
        <a href="/campaign/chart/" class="question__header">
          <img src="../../static/header_logo.svg" alt="ティップネスキッズロゴ" class="question__header-logo">
          <p class="question__header-title">ティップネス・キッズ</p>
        </a>
        <div :class="'question__text-bg question__text-bg--' + (Number(questionNumber) + 1)">
          <p :class="'question__title question__title--'+ (Number(questionNumber) + 1)" v-html="this.questionTitle">
          </p>
          <span v-if="this.questionSubTitle" class="question__title question__title--sub"
                v-html="this.questionSubTitle"></span>
        </div>
      </div>
    </div>
    <div class="question__body">
      <div class="question__body-container">
        <p class="question__annotation">いずれかをタップ</p>
        <div class="question__button-list">
          <div class="question__button-wrap" v-for="(answer, index) in answers">
            <a href="javascript:;" @click="$emit('click', { questionNumber: questionNumber, value: index+1 })">
              <div :class="'question__button question__button--' + numberToString(index+1)">
                <p :class="answer.split('@').length > 1 ? 'question__button-text question__button-text--small' : 'question__button-text'">{{ answer.split('@')[0] }}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Question',
  props: {
    answers: {
      type: Array,
      required: true,
      default: []
    },
    questionTitle: {
      type: String,
      required: true,
      default: ""
    },
    questionNumber: {
      type: Number,
      required: true,
      default: 0
    },
    userAnswers: {
      type: Array,
      required: true,
      default: []
    },
    questionSubTitle: {
      type: String,
    },
  },
  methods: {
    numberToString(number) {
      switch (number) {
        case 1:
          return "first"
        case 2:
          return "second"
        case 3:
          return "third"
        case 4:
          return "fourth"
      }
    }
  },
  computed: {
    answerCount() {
      return this.userAnswers.length
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.question {
  margin: 0 auto;
  background: url("../question_bg.svg") top center /contain;
}

.question__top {
  max-width: 375px;
  width: 100%;
  margin: 0 auto;
  background-size: cover;
}

.question__header{
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  margin-top: -10px;
}

.question__header-logo{
  width: 42px;
  height: 42px;
}

.question__header-title{
  display: inline-block;
  margin-left: 9px;
  font-size: 22px;
  color: #1E2D73;
  letter-spacing: -2px;
}

.question__title-wrap {
  position: relative;
  max-width: 375px;
  margin: 0 auto;
  height: 297px;
  padding-top: 23px;
}

.question__title-wrap--1 {
  background: url("../question_title_bg1.png") top center no-repeat;
}

.question__title-wrap--2 {
  background: url("../question_title_bg2.png") top center no-repeat;
}

.question__title-wrap--3 {
  background: url("../question_title_bg3.png") top center no-repeat;
}

.question__title-wrap--4 {
  background: url("../question_title_bg4.png") top center no-repeat;
}

.question__title-wrap--5 {
  background: url("../question_title_bg5.png") top center no-repeat;
}

.question__title-wrap--6 {
  background: url("../question_title_bg6.png") top center no-repeat;
}

.question__title-wrap::before {
  display: inline-block;
  position: absolute;
  content: "";
  width: 90px;
  height: 57px;
  top: 20%;
  left: 12%;
}

.question__title-wrap--1::before {
  background: url("../question_title_label1.svg") top center no-repeat;
}

.question__title-wrap--2::before {
  background: url("../question_title_label2.svg") top center no-repeat;
}

.question__title-wrap--3::before {
  background: url("../question_title_label3.svg") top center no-repeat;
}

.question__title-wrap--4::before {
  background: url("../question_title_label4.svg") top center no-repeat;
}

.question__title-wrap--5::before {
  background: url("../question_title_label5.svg") top center no-repeat;
}

.question__title-wrap--6::before {
  background: url("../question_title_label6.svg") top center no-repeat;
}

.question__title {
  position: absolute;
  display: inline-block;
  width: 100%;
  padding: 30px 0;
  font-size: 29px;
  line-height: 42px;
  letter-spacing: 4px;
  top: 91px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  text-shadow: #fff 3px 0px, #fff -3px 0px,
  #fff 0px -3px, #fff 0px 3px,
  #fff 3px 3px, #fff -3px 3px,
  #fff 3px -3px, #fff -3px -3px,
  #fff 2px 3px, #fff -2px 3px,
  #fff 2px -3px, #fff -2px -3px,
  #fff 3px 2px, #fff -3px 2px,
  #fff 3px -2px, #fff -3px -2px;
}

.question__title--2 {
  top: 110px;
}

.question__title--3 {
  top: 86px;
  line-height: 39px;
}

.question__title--4 {
  top: 88px;
  line-height: 39px;
}

.question__title--sub {
  font-size: 13px;
  top: 168px;
  line-height: 1.5;
  letter-spacing: 2px;
  text-shadow: #fff 2px 0px, #fff -2px 0px,
  #fff 0px -2px, #fff 0px 2px,
  #fff 2px 2px, #fff -2px 2px,
  #fff 2px -2px, #fff -2px -2px,
  #fff 2px 2px, #fff -2px 2px,
  #fff 2px -2px, #fff -2px -2px,
  #fff 2px 2px, #fff -2px 2px,
  #fff 2px -2px, #fff -2px -2px;
}

.question__body {
  position: relative;
  padding-bottom: 70px;
}

.question__body-container {
  padding: 0 16px;
}

.question__annotation {
  position: relative;
  display: inline-block;
  margin-right: 14px;
  margin-top: 5px;
  margin-bottom: 26px;
  font-size: 16px;
  color: #1B1C3B;
}

.question__annotation::after {
  position: absolute;
  display: block;
  content: "";
  width: 10px;
  height: 8px;
  background: url("../question_arrow.png") top center;
  top: 50%;
  right: -14px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}

.question__button-list {
  display: flex;
  flex-direction: column;
  max-width: 343px;
  margin: 0 auto;
}

.question__button-wrap {
  margin-bottom: 19px;
}

.question__button {
  position: relative;
  display: inline-block;
  width: 100%;
  padding: 33px 0;
  background-color: #fff;
  font-size: 21px;
  line-height: 1;
  letter-spacing: 1px;
  border-radius: 36px;
  text-decoration: none;
  color: #1B1C3B;
  z-index: 2;
}

@media screen and (max-width: 350px) {
  .question__title {
    font-size: 22px;
  }
  
  .question__title--sub{
    font-size: 13px;
  }

  .question__button {
    font-size: 18px;
  }
}

.question__button-text {
  position: absolute;
  display: inline-block;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  z-index: 2;
  text-shadow: #fff 2px 0px, #fff -2px 0px,
  #fff 0px -2px, #fff 0px 2px,
  #fff 2px 2px, #fff -2px 2px,
  #fff 2px -2px, #fff -2px -2px,
  #fff 1px 2px, #fff -1px 2px,
  #fff 1px -2px, #fff -1px -2px,
  #fff 2px 1px, #fff -2px 1px,
  #fff 2px -1px, #fff -2px -1px;
}

.question__button-text--small {
  font-size: 17px;
}

.question__button--first {
  border: 3px solid #48A035;
  color: #48A035;
}

.question__button--first::after {
  position: absolute;
  display: inline-block;
  content: "";
  background: url("../question_button1.svg") top center no-repeat;
  background-size: contain;
  max-width: 343px;
  width: 100%;
  height: 72px;
  bottom: 0;
  right: 0;
  z-index: 1;
}

.question__button--second {
  border: 3px solid #018CD7;
  color: #018CD7;
}

.question__button--second::after {
  position: absolute;
  display: inline-block;
  content: "";
  background: url("../question_button2.svg") bottom center no-repeat;
  background-size: contain;
  max-width: 343px;
  width: 100%;
  height: 72px;
  bottom: 0;
  right: 0;
  z-index: 1;
}

.question__button--third {
  border: 3px solid #F7772F;
  color: #F7772F;
}

.question__button--third::after {
  position: absolute;
  display: inline-block;
  content: "";
  background: url("../question_button3.svg") bottom center no-repeat;
  background-size: contain;
  max-width: 343px;
  width: 100%;
  height: 72px;
  bottom: 0;
  right: 0;
  z-index: 1;
}

.question__button--fourth {
  border: 3px solid #FF76E2;
  color: #FF76E2;
}

.question__button--fourth::after {
  position: absolute;
  display: inline-block;
  content: "";
  background: url("../question_button4.svg") bottom center no-repeat;
  background-size: contain;
  max-width: 343px;
  width: 100%;
  height: 72px;
  bottom: 0;
  right: -2px;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Question.vue